<template>
    <!-- <div class="page-wrapper-sec">
    <div class="page-title">
    404
  </div>
  <div class="page-content">
    <div class="row m-0">
      Page Not Found!
    </div>
  </div>
  </div> -->
  <el-row class="error_page">
    <el-col :span="24" class="main_center">
      <div class="text-center">
        <img class="m-b-20" src="/static/images/404 error.svg"/>
      </div>
      <div class="error_txt">404 Page Not Found</div>
      <div class="error_smtext">The HTTP 404 Not Found Error means that
          the webpage you were trying to reach could not be
          found on the server. 
      </div>
    </el-col>
  </el-row>
</template>
<script>
import UI_RULES from '../../util/ui-rules.js'
export default {
  name: 'page-no-found-view',
  data () {
    return { }
  },
  mounted:function(){
    UI_RULES.updateRules(this.$store, null)
  },
  title () { return '' }
}
</script>
<style lang="css">
.error_txt{color: #000000;	font-size: 18px;	font-weight: 600;	line-height: 27px;	text-align: center;}
.main_center{margin: 12% 0%;}
.error_smtext{color: #88909c;font-size: 14px;line-height: 21px;text-align: center;margin: 1% 37%;}
.error_page{height: 702px;border-radius: 3px;background-color: #FFFFFF;box-shadow: 0 4px 20px 0 rgba(153,150,250,0.13);margin-top: 50px;}
</style>


// WEBPACK FOOTER //
// src/views/common/404.vue